const comments = [
  {
    name: '吃瓜不嫌事大',
    avatar: '🍉',
    time: '3分钟前',
    content: '这个瓜我吃了三天了，每天都有新反转！51黑料吃瓜网的更新速度真的太快了，比微博热搜还及时，爱了爱了。',
    likes: 2389,
  },
  {
    name: '深夜吃瓜人',
    avatar: '🦉',
    time: '15分钟前',
    content: '本来只是随便点进来看看，结果一口气刷了两个小时。51吃瓜在线观看的内容太全了，好多在其他平台看不到的细节这里都有。',
    likes: 1856,
  },
  {
    name: '理性吃瓜群众',
    avatar: '🧐',
    time: '42分钟前',
    content: '建议大家理性吃瓜，不要盲目站队。不过不得不说，这里的黑料在线播放画质确实高清流畅，体验没话说。',
    likes: 1520,
  },
  {
    name: '今天你吃瓜了吗',
    avatar: '🍵',
    time: '1小时前',
    content: '作为资深吃瓜人，我可以负责任地说，51黑料吃瓜网是目前内容最全、更新最快的平台，没有之一！每天必刷，少一天都不行。',
    likes: 3201,
  },
  {
    name: '八卦研究所所长',
    avatar: '🔍',
    time: '2小时前',
    content: '这块瓜的来龙去脉我算是理清楚了，感谢博主整理！吃瓜在线视频栏目的专题做得特别用心，时间线一目了然。强烈安利！',
    likes: 978,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            吃瓜群众热评
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            真实瓜友，真实声音
          </p>
        </div>

        <div className="space-y-4">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/50 rounded-xl p-4 md:p-5 hover:border-primary-200/40 transition-colors"
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-primary-100 flex items-center justify-center text-xl flex-shrink-0">
                  {comment.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-foreground-800">
                      {comment.name}
                    </span>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
                    {comment.content}
                  </p>
                  <div className="flex items-center gap-4">
                    <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-thumb-up-line"></i>
                      <span>{comment.likes.toLocaleString()}</span>
                    </button>
                    <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-chat-1-line"></i>
                      回复
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}